import { render, staticRenderFns } from "./GlobalFeatureFilters.vue?vue&type=template&id=1148e275"
import script from "./GlobalFeatureFilters.vue?vue&type=script&lang=js"
export * from "./GlobalFeatureFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports